import { render, staticRenderFns } from "./AllocationReportPage.vue?vue&type=template&id=d188209c&"
import script from "./AllocationReportPage.vue?vue&type=script&lang=js&"
export * from "./AllocationReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports